import React from "react";

// Schlichter Button-Ersatz – übernimmt einfach className/onClick/disabled.
export const Button = ({ children, className = "", variant, size, ...props }) => (
  <button className={className} {...props}>
    {children}
  </button>
);
